import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Clickable from '../framework/clickable';
import GroupLink from '../framework/group_link';
import Link from '../framework/link';
import BookingBadge from './booking_badge';

const LocationItem = ({
	address,
	city,
	className = '',
	groups,
	location_id,
	location_settings,
	onGotoMarker,
	position,
	title,
}) => {
	const { t } = useTranslation('component_location_item');

	return (
		<Clickable is="section">
			<div
				className={`location-item card rounded-0 border-0 mb-1 ${className}`}
				role="button"
			>
				<div className="card-body px-0 py-3">
					<div className="row">
						<div className="col">
							<h3 className="location-list-title fw-700 mb-0">{title}</h3>
							<p
								className={`xs text-muted ${position?.distance_unit ? 'mb-0' : ''}`}
							>
								{address}
								{', '}
								{city}
							</p>
							{position?.distance_unit && (
								<p className="xs">
									{position?.distance_unit} {t('t5')}
								</p>
							)}
						</div>
						<div className="col-auto">
							<BookingBadge
								dropIn={location_settings?.url_book ? false : true}
							/>
						</div>
					</div>

					<div className="row">
						<div className="col-12 col-md-8 mt-2 mt-md-0 pe-3">
							<div className="row">
								<div className="col-auto">
									{/*
									<p className="nowrap x-small mb-0 text-dark">
										<span className="fw-600">{t('t1')}</span>
										{' · '}
										<span className="">
											{location_settings?.opening_hours_monday
												? location_settings.opening_hours_monday
												: t('t2')}
										</span>
									</p>
									*/}
									<div className="xs">
										{onGotoMarker && (
											<>
												<Link
													className="fw-600 d-inline clickable-ignore"
													onClick={onGotoMarker}
													to="#"
												>
													{t('t3')}
												</Link>
												{' · '}
											</>
										)}
										<GroupLink
											className="clickable fw-600 d-inline"
											groups={groups}
											location_id={location_id}
											page="mottagningar"
										>
											{t('t4')}
										</GroupLink>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Clickable>
	);
};

LocationItem.propTypes = {
	address: PropTypes.string,
	city: PropTypes.string,
	className: PropTypes.string,
	groups: PropTypes.array,
	location_id: PropTypes.number,
	location_settings: PropTypes.object,
	onGotoMarker: PropTypes.func,
	position: PropTypes.object,
	title: PropTypes.string,
};

export default LocationItem;
